import React from 'react';
import { ModalConsumer } from 'packages/modal';

const ModalRender = () => (
  <ModalConsumer>
    {({ components, hideModal }) =>
      components.map(
        ({ Component, props }) =>
          Component ? (
            <Component {...props} key={Component} onRequestClose={hideModal} />
          ) : null,
      )
    }
  </ModalConsumer>
);

export default ModalRender;



// WEBPACK FOOTER //
// /opt/build/repo/src/packages/modal/components/ModalRender.js